import React from "react";
import { useTranslation } from "react-i18next";

function EventHighlight({ innerRef }) {
  const { t } = useTranslation();

  return (
    <section ref={innerRef} id="eventHighlight" className="event-highlight">
      <div className="event-highlight-media">
        <video loop muted autoPlay playsInline>
          <source
            src="/assets/images/made-in-the-emirates-2025.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="event-highlight-overlay" />

      <div className="event-highlight-content">
        <div className="event-highlight-copy">
          <span className="event-highlight-kicker">
            {t("eventHighlightKicker")}
          </span>
          <h2>{t("eventHighlightTitle")}</h2>
          <p className="event-highlight-lead">{t("eventHighlightLead")}</p>
        </div>

        <div className="event-highlight-panels">
          <div className="event-highlight-meta">
            <span className="event-meta-label">
              {t("eventHighlightMetaTitle")}
            </span>
            <div className="event-meta-item">
              <span>{t("eventHighlightStartLabel")}</span>
              <strong>{t("eventHighlightStartDate")}</strong>
            </div>
            <div className="event-meta-item">
              <span>{t("eventHighlightEndLabel")}</span>
              <strong>{t("eventHighlightEndDate")}</strong>
            </div>
            <div className="event-meta-item">
              <span>{t("eventHighlightTimeLabel")}</span>
              <strong>{t("eventHighlightTime")}</strong>
            </div>
            <div className="event-meta-item">
              <span>{t("eventHighlightLocationLabel")}</span>
              <strong>{t("eventHighlightLocation")}</strong>
            </div>
          </div>

          <div className="event-highlight-details">
            <p>{t("eventHighlightDescription")}</p>
            <div className="event-highlight-actions">
              <a
                className="btn bg-white text-dark"
                href="https://www.miite.ae/en/enquire-to-exhibit"
                target="_blank"
                rel="noreferrer"
              >
                {t("eventHighlightPrimaryAction")}
              </a>
              <a
                className="btn btn-outline-light"
                href="https://registration.xporience.com/registration/?token=JzKm6Alim3lxsVt&badge_name=visitor"
                target="_blank"
                rel="noreferrer"
              >
                {t("eventHighlightSecondaryAction")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default EventHighlight;
